import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import CarSingle from "../../components/carSingle/carSingle.component";
import {
  selectNewRequestVehicles,
  selectVehicleType,
  selectNewRequestSelectedVehicle,
} from "../../redux/newRequest/newRequest.selectors";

const CarList = ({
  selectNewRequestVehicles,
  selectNewRequestSelectedVehicle,
  selectVehicleType,
  second,
}) => {
  // const [filteredVehicle,setFilteredVehicle]=useState(selectNewRequestVehicles)
  console.log("emam2", selectNewRequestVehicles);
  // selectNewRequestVehicles?.map((item) => item.volume_category===selectVehicleType?setFilteredVehicle([item]):console.log('emam',"nist"))
  const selectActive = (item) => {
    if (selectNewRequestSelectedVehicle._id === item._id) return true;
    // debugger;
    return false;
  };
  // volume_category
  return (
    <div className={`overflow-hidden ${second && "py-2"}`}>
      {selectNewRequestVehicles?.map((item) =>
        item.volume_category === selectVehicleType ? (
          <CarSingle
            key={item._id}
            info={item}
            active={selectActive(item)}
            second
          />
        ) : (
          ""
        )
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestVehicles: selectNewRequestVehicles,
  selectNewRequestSelectedVehicle: selectNewRequestSelectedVehicle,
  selectVehicleType: selectVehicleType,
});

export default connect(mapStateToProps)(CarList);
